export default "__VITE_ASSET__BmSqGOcj__"